module.exports = __webpack_public_path__ + "img/social_logomark.c851091d.png";